import * as types from './mutation-types'

export default {
  [types.ADD_INTERVALS](state, data) {
    state.intervals = data
  },
  [types.ADD_INTERVAL] (state, data) {
    state.intervals.push(data)
  },
}
